import { render, staticRenderFns } from "./PlatformModalInfo.vue?vue&type=template&id=a028157e&scoped=true"
import script from "./PlatformModalInfo.vue?vue&type=script&lang=js"
export * from "./PlatformModalInfo.vue?vue&type=script&lang=js"
import style0 from "./PlatformModalInfo.vue?vue&type=style&index=0&id=a028157e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a028157e",
  null
  
)

export default component.exports